import { toast } from "@/components/Toast"

type Options = {
  onSuccess?: () => void
  onError?: () => void
  successMessage?: string
}

export const copyToClipboard = (copyText: string, options?: Options) => {
  navigator.clipboard
    .writeText(copyText)
    .then(() => {
      toast(options?.successMessage || "Copied to clipboard", { icon: "📋" })
      options?.onSuccess?.()
    })
    .catch(err => {
      toast.error("Failed to copy")
      console.error("Failed to copy: ", err)
      options?.onError?.()
    })
}
